import { ViewModel, View, ObservableArray, ViewModelMessage, DelegatedObservableArrayChangeListenner } from "binder"
import { CurrentCredentials } from "src/server/currentCredentials";
import { ServerConnection } from "src/server/serverConnection";
import { SideBarItem } from "src/uicomponents/components/sidebar/sidebar-viewModel";
import { MediaSelector } from "uicomponents";
import { ThemeSelectorViewModel } from "../themeSelector/themeSelector-viewModel";
import { stringIsNullOrEmpty, translate } from "../utilities";
import { WindowFactory } from "../windowFactory";
import { UserMainWindowView } from "./userMainWindow-view"
import { UserMainWindowPhoneView } from "./userMainWindowPhone/userMainWindowPhone-view";
import { RequestCloseWindowMessage, WindowContainerViewModel, WindowViewModel } from "./windowContainer/windowContainer-viewModel";
import { ShowMessageBoxMessage } from "src/binder/uiPatterns/mvvm/viewmodel";
import { RegisterForServerNotification, ServerNotification } from "src/server/serverNotification";
import { NotificationsPopupViewModel } from "./notifications/notificationsPopup/notificationsPopup-viewModel";
import { StartupNotificationsViewModel } from "./notifications/startupNotifications/startupNotifications-viewModel";
import { HomePageViewModel } from "../homePage/homePage-viewModel";
declare var Lobibox;
declare var deferredPromptForPwaPrompt;
declare var raisedForPwaPrompt;
declare var applicationTitleInForms;
declare var ourSystemName;
declare var showSidebarIcons;
export class UserMainWindowViewModel extends ViewModel {

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.applicationTitle = applicationTitleInForms;
        this.ourSystemName = ourSystemName;
        this.autohide = false;
        this.favorites = ObservableArray.create<AccessibleFormViewModel>();
        this.favoriteFilter = new FavoriteFilter(this);
        this.favoriteFilter.accessibles = this.favorites;
        this.showFavorites = false;
        this.hasFavorites = false;
        this.forms = ObservableArray.create<WindowContainerViewModel>();
        this.filter = new FilterAccessibleFormsViewModel(this);
        this.loggedInPersonnelName = CurrentCredentials.personnelFullName;
        this.loggedInPersonnelCode = CurrentCredentials.personnelCode;
        this.hasPicture = false;
        this.showSidebarIcons = showSidebarIcons;
        this.loadPersonnelPicture();
        this.updateShallInstall();
        this.monitorUserActivity();
        this.serverNotification = new ServerNotification(() => CurrentCredentials.username, () => CurrentCredentials.password);
        this.serverNotification.handleMessage(new RegisterForServerNotification("NewNotification", (x, y) => {
            let msg = <any>y;
            let alertType = msg.AlertType;
            let type = '';
            let icon = '';
            switch (alertType) {
                case 1:
                    type = 'successs';
                    icon = 'notification-successs';
                    break;
                case 2:
                    type = 'info';
                    icon = 'notification-information';
                    break;
                case 3:
                    type = 'warning';
                    icon = 'notification-warning';
                    break;
                case 4:
                    type = 'error';
                    icon = 'notification-error';
                    break;
            }

            Lobibox.notify(type, {
                pauseDelayOnHover: true,
                continueDelayOnInactiveTab: false,
                title: msg.Title,
                msg: msg.Body,
                delay: 1000000,
                messageHeight: 'auto',
                icon: `bi ${icon}`,
            });
            setTimeout(() => {
                this.userNotificationsPopup?.refresh();
            }, 1000);
        }));
        this.userNotificationsPopup = new NotificationsPopupViewModel(this);
        setTimeout(() => this.loadStartupNotifications(), 1000);
        this.reloadHomaePage();
    }

    reloadHomaePage():void{
        this.homePageViewModel = this.addHomePageWindow();
    }

    GetDefaultView(): View<ViewModel> {
        return MediaSelector.GetView({
            default: () => new UserMainWindowView(),
            portraitPhone: () => new UserMainWindowPhoneView(),
            landscapePhone: () => new UserMainWindowPhoneView(),
        });
    }
    public getTypeId(): string {
        return "VM-15D1595C-4B19-4E39-B4C5-FB4DEB2023AA"
    }
    private serverNotification: ServerNotification;
    async loadPersonnelPicture() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetPersonnelPicture', {
                PersonnelId: CurrentCredentials.personnelId
            });
            this.pictureFileName = result.PictureFileName;
            this.pictureFileData = result.PictureData;
            if (result.HasPicture) {
                this.hasPicture = true;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || (<any>window).opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !(<any>window).MSStream) {
            return "iOS";
        }

        return "unknown";
    }

    private updateShallInstall() {
        if (localStorage.getItem("pwa-installed")) {
            this.shallShowInstall = false;
        } else if (raisedForPwaPrompt === true) {
            this.shallShowInstall = true;
        } else {
            let type = this.getMobileOperatingSystem();
            if (type == 'Android' || type == 'iOS') {
                this.shallShowInstall = true;
            } else {
                this.shallShowInstall = false;
            }
        }
    }
    private monitorUserActivity(): void {
        // const activityEvents = ['mousemove', 'mousedown', 'wheel', 'keydown', 'touchstart', 'touchmove'];
        // const resetLogoutTimer = () => {
        //     if (this.logoutTimer) {
        //         clearTimeout(this.logoutTimer);
        //     }
        //     this.logoutTimer = setTimeout(() => {
        //         this.handleMessage(new UserInactivityLogoutMessage())
        //     }, 1000 * 60 * 15); // 15 minutes
        // };
        // activityEvents.forEach(ev => window.addEventListener(ev, resetLogoutTimer));
    }
    install() {
        if (raisedForPwaPrompt === true) {
            deferredPromptForPwaPrompt.prompt();
            deferredPromptForPwaPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    localStorage.setItem("pwa-installed", "true");
                } else {
                }
                deferredPromptForPwaPrompt = null;
            });
        } else {
            let type = this.getMobileOperatingSystem();
            if (type == 'Android') {
                this.messageBoxConfirmSuccess(translate("userMainWindow-viewModel.addToHomeScreen", {}), translate("userMainWindow-viewModel.add", {}));
            } else if (type == 'iOS') {
                this.messageBoxConfirmSuccess(translate("userMainWindow-viewModel.addToHomeScreen", {}), translate("userMainWindow-viewModel.add", {}));
            }
        }

    }

    public set shallShowInstall(v: boolean) { this._shallShowInstall = v; } public get shallShowInstall(): boolean { return this._shallShowInstall; } private _shallShowInstall: boolean;
    public set userNotificationsPopup(v: NotificationsPopupViewModel) { this._userNotificationsPopup = v; } public get userNotificationsPopup(): NotificationsPopupViewModel { return this._userNotificationsPopup; } private _userNotificationsPopup: NotificationsPopupViewModel;
    public set applicationTitle(v: string) { this._applicationTitle = v; } public get applicationTitle(): string { return this._applicationTitle; } private _applicationTitle: string;
    public set homePageViewModel(v: HomePageViewModel) { this._homePageViewModel = v; } public get homePageViewModel(): HomePageViewModel { return this._homePageViewModel; } private _homePageViewModel: HomePageViewModel;
    public set showSidebarIcons(v: boolean) { this._showSidebarIcons = v; } public get showSidebarIcons(): boolean { return this._showSidebarIcons; } private _showSidebarIcons: boolean;
    public set logoutTimer(v: NodeJS.Timeout) { this._logoutTimer = v; } public get logoutTimer(): NodeJS.Timeout { return this._logoutTimer; } private _logoutTimer: NodeJS.Timeout;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set forms(v: ObservableArray<WindowContainerViewModel>) { this._forms = v; } public get forms(): ObservableArray<WindowContainerViewModel> { return this._forms; } private _forms: ObservableArray<WindowContainerViewModel>;
    public set currentForm(v: WindowContainerViewModel) {
        this._currentForm = v;
        if (v?.window == this.homePageViewModel) {
            setTimeout(() => {
                this.homePageViewModel.tryRedraw();
            }, 0)
        }
        if (v?.window?.isShowingPopup == true) {
            v.window.isShowingPopup = false;
            setTimeout(() => {
                v.window.isShowingPopup = true;
            }, 100)
        }
    } public get currentForm(): WindowContainerViewModel { return this._currentForm; } private _currentForm: WindowContainerViewModel;
    public set filter(v: FilterAccessibleFormsViewModel) { this._filter = v; } public get filter(): FilterAccessibleFormsViewModel { return this._filter; } private _filter: FilterAccessibleFormsViewModel;
    public set hasPicture(v: boolean) { this._hasPicture = v; } public get hasPicture(): boolean { return this._hasPicture; } private _hasPicture: boolean;
    public set pictureFileName(v: string) { this._pictureFileName = v; } public get pictureFileName(): string { return this._pictureFileName; } private _pictureFileName: string;
    public set pictureFileData(v: string) { this._pictureFileData = v; } public get pictureFileData(): string { return this._pictureFileData; } private _pictureFileData: string;

    public set loggedInPersonnelName(v: string) { this._loggedInPersonnelName = v; } public get loggedInPersonnelName(): string { return this._loggedInPersonnelName; } private _loggedInPersonnelName: string;
    public set loggedInPersonnelCode(v: string) { this._loggedInPersonnelCode = v; } public get loggedInPersonnelCode(): string { return this._loggedInPersonnelCode; } private _loggedInPersonnelCode: string;
    public set autohide(v: boolean) { this._autohide = v; } public get autohide(): boolean { return this._autohide; } private _autohide: boolean;
    public set themeWindow(v: ThemeSelectorViewModel) { this._themeWindow = v; } public get themeWindow(): ThemeSelectorViewModel { return this._themeWindow; } private _themeWindow: ThemeSelectorViewModel;
    public set shallShowThemes(v: boolean) { this._shallShowThemes = v; } public get shallShowThemes(): boolean { return this._shallShowThemes; } private _shallShowThemes: boolean;
    public set favoriteFilter(v: FavoriteFilter) { this._favoriteFilter = v; } public get favoriteFilter(): FavoriteFilter { return this._favoriteFilter; } private _favoriteFilter: FavoriteFilter;

    public set favorites(v: ObservableArray<AccessibleFormViewModel>) { this._favorites = v; } public get favorites(): ObservableArray<AccessibleFormViewModel> { return this._favorites; } private _favorites: ObservableArray<AccessibleFormViewModel>;
    public set hasFavorites(v: boolean) { this._hasFavorites = v; } public get hasFavorites(): boolean { return this._hasFavorites; } private _hasFavorites: boolean;
    public set showFavorites(v: boolean) { this._showFavorites = v; } public get showFavorites(): boolean { return this._showFavorites; } private _showFavorites: boolean;
    public set ourSystemName(v: string) { this._ourSystemName = v; } public get ourSystemName(): string { return this._ourSystemName; } private _ourSystemName: string;

    toggleShowFavorite() {
        this.showFavorites = !this.showFavorites;
    }

    async loadStartupNotifications() {
        try {
            let result = await ServerConnection.callServer('/Complex/UserNotifications/GetUnShownStartupNotifications', {

            });
            let items: [] = result.Notifications.map(x => {
                return {
                    header: x.Title,
                    body: x.Body
                }
            });
            if (items.length > 0) {
                let showStartUpNotificationsMessage = new ShowWindowMessage(p => {
                    let window = new StartupNotificationsViewModel(p);
                    window.show(items);
                    return window;
                });
                this.handleMessage(showStartUpNotificationsMessage);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }

    private async ShowMessageBox(message: ShowMessageBoxMessage) {
        if (this.currentForm == undefined) {

            let windowMessage = new CreateWindowMessage("712830b8-3b83-4d49-af06-8686b3887f96");
            let window = await this.handleMessage(windowMessage);
            await new Promise((res) => setTimeout(() => res("p1"), 100));
            let oldResolveFunction = message.resolveFunction;
            message.resolveFunction = s => {
                (<WindowContainerViewModel>window).close();
                oldResolveFunction(s);
            }
            let result = await window.handleMessage(message);
            return result;
        }
        return this.currentForm.handleMessage(message);
    }

    private addHomePageWindow(): HomePageViewModel {
        let windowContainer = new WindowContainerViewModel(this);
        let window = new HomePageViewModel(this);
        windowContainer.window = window;
        this.forms.push(windowContainer);
        this.currentForm = windowContainer;
        return window;
    }

    private async addNewWindowFromMessage(message: CreateWindowMessage): Promise<WindowContainerViewModel> {
        let windowContainer = new WindowContainerViewModel(this);
        let window = await new WindowFactory().getWindow(message, windowContainer);
        windowContainer.window = window;
        this.forms.push(windowContainer);
        this.currentForm = windowContainer;
        return windowContainer;
    }
    private async addNewWindowFromGeneraotrFunction(message: ShowWindowMessage): Promise<WindowContainerViewModel> {
        let windowContainer = new WindowContainerViewModel(this);
        let window = message.generator(windowContainer);
        windowContainer.window = window;
        this.forms.push(windowContainer);
        this.currentForm = windowContainer;
        return windowContainer;
    }
    private closeWindow(window: WindowContainerViewModel) {
        if (this.currentForm == window) {
            let position = this.forms.indexOf(window);
            this.forms.remove(window);
            if (this.forms.length == 0)
                this.currentForm = null;
            else if (this.forms.length > position) {
                this.currentForm = this.forms[position];
            } else {
                this.currentForm = this.forms[this.forms.length - 1];
            }
        } else {
            this.forms.remove(window)
        }

    }
    handleMessage(message: ViewModelMessage) {
        if (message instanceof CreateWindowMessage) {
            return this.addNewWindowFromMessage(message);
        } else if (message instanceof ShowWindowMessage) {
            return this.addNewWindowFromGeneraotrFunction(message);
        } else if (message instanceof RequestCloseWindowMessage) {
            this.closeWindow(message.window);
            return message.window;
        } else if (message instanceof FavoriteItemsChangedMessage) {
            this.updateFavoriteItems();
            return null;
        } else if (message instanceof FavoriteItemAddedRemovedMessage) {
            if (message.isAdded) {
                this.homePageViewModel?.itemAdded(message.form);
            } else {
                this.homePageViewModel?.itemRemoved(message.form);
            }
        } else {
            return super.handleMessage(message);
        }
    }
    updateFavoriteItems() {
        this.favorites.update(...this.filter.accessibleForms.filter(x => x.isFavorite));
        if (this.favorites.length == 0) {
            this.hasFavorites = false;
        } else {
            this.hasFavorites = true;
        }
        console.log(this.favorites);
    }
    toggleAutohide() {
        this.autohide = !this.autohide;
    }
    showThemeWindow() {
        this.shallShowThemes = true;
        this.themeWindow = new ThemeSelectorViewModel(this);
    }
    closeThemeWindow() {
        this.shallShowThemes = false;
        this.themeWindow = null;
    }
    async logout() {
        let result = await this.messageBoxWarningYesNo(translate("userMainWindow-viewModel.exitQuestion", {}), translate("userMainWindow-viewModel.exitApp", {}));
        if (result == 'yes') {
            location.reload();
        }
    }

    selectHomePage() {
        this.currentForm = this.forms.filter(x => x.window == this.homePageViewModel).at(0);
    }
}
export class FavoriteFilter extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.filtered = ObservableArray.create<AccessibleFormViewModel>();
        this.filterText = '';
    }

    public set filterText(v: string) {
        this._filterText = v;
        this.refreshItems();
    } public get filterText(): string { return this._filterText; } private _filterText: string;
    private _changeListenner: DelegatedObservableArrayChangeListenner;
    public set accessibles(v: ObservableArray<AccessibleFormViewModel>) {
        if (this.accessibles) {
            this.accessibles.removeChangeListenner(this._changeListenner);
        }
        this._accessibles = v;
        if (this.accessibles) {
            this._changeListenner = new DelegatedObservableArrayChangeListenner(this, () => this.refreshItems());
            this.accessibles.addChangeListenner(this._changeListenner)
            this.refreshItems();
        }
    } public get accessibles(): ObservableArray<AccessibleFormViewModel> { return this._accessibles; } private _accessibles: ObservableArray<AccessibleFormViewModel>;
    public set filtered(v: ObservableArray<AccessibleFormViewModel>) {
        this._filtered = v;
        this.refreshItems();
    } public get filtered(): ObservableArray<AccessibleFormViewModel> { return this._filtered; } private _filtered: ObservableArray<AccessibleFormViewModel>;

    private timer;
    refreshItems() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.refreshItemsInternal();
        }, 200)

    }
    refreshItemsInternal() {
        if (this.accessibles == null)
            return;
        if (stringIsNullOrEmpty(this.filterText)) {
            this.filtered.update(...this.accessibles)
        } else {
            this.filtered.update(...this.accessibles.filter(x => x.formName.includes(this.filterText)));
        }
    }

}

export class UserInactivityLogoutMessage extends ViewModelMessage {}

export class FilterAccessibleFormsViewModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.filteredAccessibleForms = ObservableArray.create<AccessibleFormViewModel>();
        this.accessibleForms = ObservableArray.create<AccessibleFormViewModel>();
        this.accessibleItems = new Map<string, AccessibleItem>();
        this.refresh();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set filteredAccessibleForms(v: ObservableArray<AccessibleFormViewModel>) { this._filteredAccessibleForms = v; } public get filteredAccessibleForms(): ObservableArray<AccessibleFormViewModel> { return this._filteredAccessibleForms; } private _filteredAccessibleForms: ObservableArray<AccessibleFormViewModel>;
    public set accessibleForms(v: ObservableArray<AccessibleFormViewModel>) { this._accessibleForms = v; } public get accessibleForms(): ObservableArray<AccessibleFormViewModel> { return this._accessibleForms; } private _accessibleForms: ObservableArray<AccessibleFormViewModel>;
    public set writtenText(v: string) {
        this._writtenText = v;
        this.startFilter();
    } public get writtenText(): string { return this._writtenText; } private _writtenText: string;

    public set sideBarItems(v: SideBarItem[]) { this._sideBarItems = v; } public get sideBarItems(): SideBarItem[] { return this._sideBarItems; } private _sideBarItems: SideBarItem[];
    public set accessibleItems(v: Map<string, AccessibleItem>) { this._accessibleItems = v; } public get accessibleItems(): Map<string, AccessibleItem> { return this._accessibleItems; } private _accessibleItems: Map<string, AccessibleItem>;
    private pathIcons: { path: string, icon: string }[] = [];
    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/AuthorizationServices/GetAccessibleFormsForCurrentUser', {});
            let forms: AccessibleFormViewModel[] = result.Forms.map(x => {
                let r = new AccessibleFormViewModel(this);
                r.formId = x.Id;
                r.formName = x.Name;
                r.processFormId = x.ProcessFormId;
                r.processFormName = x.ProcessFormName;
                r.position = x.Position;
                r.isFavorite = x.IsFavorite;
                r.icon = x.Icon;
                return r;
            });
            this.pathIcons = result.PathIcons.map(x => {
                return {
                    path: x.FullPath,
                    icon: x.Icon
                }
            });
            let menu = new Menu();
            forms.forEach(x => menu.addChild(x.formName.split('/'), x.position, x));
            menu.sort();
            forms = menu.getSortedData();
            this.accessibleForms.update(...forms);
            this.writtenText = "";
            this.filteredAccessibleForms.update(...this.accessibleForms);
            this.updateSideBarItems();
            this.handleMessage(new FavoriteItemsChangedMessage());
        }
        catch (ex) {
            console.log(ex);
        }
        finally {
            this.isLoading = false;
        }
    }
    private timer: any;
    startFilter() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.filteredAccessibleForms.update(...this.accessibleForms.filter(x => x.formName.includes(this.writtenText)));
            this.updateSideBarItems();
        }, 200);

    }

    updateSideBarItems() {
        this.accessibleItems.clear();
        let tempArray: SideBarItem[] = new Array();
        this.filteredAccessibleForms.forEach(element => {
            this.CreateAccessibleFormChains(element);
        });
        this.accessibleItems.forEach(element => {
            let sideBarItem = element.getCorrespondingSideBarItem();
            tempArray.push(sideBarItem);
        });
        this.sideBarItems = tempArray.slice();
    }

    CreateAccessibleFormChains(form: AccessibleFormViewModel) {
        let parts: string[] = form.formName.split("/");
        let lastChainedItem: AccessibleItem = null;
        while (parts.length != 0) {
            if (lastChainedItem == null) {
                if (this.accessibleItems.has(parts[0])) {
                    lastChainedItem = this.accessibleItems.get(parts[0]);
                    parts.splice(0, 1);
                    continue;
                }
                break;
            }
            else {
                if (lastChainedItem.hasChild(parts[0])) {
                    let targetChild = lastChainedItem.getChild(parts[0]);
                    lastChainedItem = targetChild;
                    parts.splice(0, 1);
                    continue;
                }
                break;
            }

        }
        for (let index = 0; index < parts.length; index++) {
            let accessibleItem = new AccessibleItem();
            accessibleItem.name = parts[index];
            accessibleItem.iconClass = "";
            if (index == parts.length - 1) {
                accessibleItem.accessibleForm = form;
                accessibleItem.iconClass = form.icon;
                accessibleItem.isFavorite = form.isFavorite;
            } else {
                let fullParts: string[] = form.formName.split("/");
                let omitedPartsCount = fullParts.length - parts.length;
                let requiredPartsCount = omitedPartsCount + index + 1;
                let path = `/${fullParts.slice(0, requiredPartsCount).join('/')}`;
                accessibleItem.iconClass = this.pathIcons.filter(x => x.path == path).at(0)?.icon;
            }
            if (index == 0 && lastChainedItem == null) {
                this.accessibleItems.set(accessibleItem.name, accessibleItem);
                lastChainedItem = accessibleItem;
                continue;
            }
            lastChainedItem.children.push(accessibleItem);
            lastChainedItem = accessibleItem;
        }
    }
}
export class FavoriteItemsChangedMessage extends ViewModelMessage {

}
export class FavoriteItemAddedRemovedMessage extends ViewModelMessage {
    public form: AccessibleFormViewModel;
    public isAdded: boolean;

    constructor(form: AccessibleFormViewModel, isAdded: boolean) {
        super();
        this.form = form;
        this.isAdded = isAdded;
    }
}
export class AccessibleFormViewModel extends ViewModel {
    async setFavorite(x: boolean) {
        this.isFavorite = x;
        this.handleMessage(new FavoriteItemsChangedMessage());
        this.handleMessage(new FavoriteItemAddedRemovedMessage(this, x));
        try {
            await ServerConnection.callServer('/Complex/SecurityRawDataServices/ChangeFavoriteMenu', {
                FormId: this.formId,
                IsSet: x
            });
        } catch (ex) {
            this.messageBoxConfirmWarning(translate("userMainWindow-viewModel.errorItems", {}), translate("userMainWindow-viewModel.error", {}));
        } finally {
        }
    }
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.showSidebarIcons = showSidebarIcons;
    }

    public set formName(v: string) { this._formName = v; } public get formName(): string { return this._formName; } private _formName: string;
    public set formId(v: string) { this._formId = v; } public get formId(): string { return this._formId; } private _formId: string;
    public set processFormId(v: string) { this._processFormId = v; } public get processFormId(): string { return this._processFormId; } private _processFormId: string;
    public set processFormName(v: string) { this._processFormName = v; } public get processFormName(): string { return this._processFormName; } private _processFormName: string;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position; } private _position: number;
    public set isFavorite(v: boolean) { this._isFavorite = v; } public get isFavorite(): boolean { return this._isFavorite; } private _isFavorite: boolean;
    public set icon(v: string) { this._icon = v; } public get icon(): string { return this._icon; } private _icon: string;
    public set showSidebarIcons(v: boolean) { this._showSidebarIcons = v; } public get showSidebarIcons(): boolean { return this._showSidebarIcons; } private _showSidebarIcons: boolean;

    select() {
        if (stringIsNullOrEmpty(this.processFormId) == false) {
            let message = new CreateWindowMessage('5ec1473c-34a7-467a-9ec4-b039fa416a8c');
            message.isProcessForm = true;
            message.processFormId = this.processFormId;
            message.processFormName = this.formName.split('/').at(-1);
            this.handleMessage(message);
        } else {
            let message = new CreateWindowMessage(this.formId);
            this.handleMessage(message);

        }
    }
}


export class CreateWindowMessage extends ViewModelMessage {
    public windowId: string;
    public isProcessForm: boolean;
    public processFormId: string;
    public processFormName: string;

    constructor(windowId: string) {
        super();
        this.windowId = windowId;
    }
}
export class ShowWindowMessage extends ViewModelMessage {
    public generator: (parent: ViewModel) => WindowViewModel;
    constructor(generator: (parent: ViewModel) => WindowViewModel) {
        super();
        this.generator = generator;
    }
}

export class AccessibleItem {
    constructor() {
        this.children = ObservableArray.create<AccessibleItem>();
    }
    public name: string;
    public iconClass: string;
    public isFavorite: boolean;
    public accessibleForm: AccessibleFormViewModel;
    public set children(v: ObservableArray<AccessibleItem>) { this._children = v; } public get children(): ObservableArray<AccessibleItem> { return this._children; } private _children: ObservableArray<AccessibleItem>;

    hasChild(key: string): boolean {
        for (let index = 0; index < this.children.length; index++) {
            const child = this.children[index];
            if (child.name == key) {
                return true;
            }
        }
        return false;
    }

    getChild(key: string): AccessibleItem {
        for (let index = 0; index < this.children.length; index++) {
            const child = this.children[index];
            if (child.name == key) {
                return child;
            }
        }
        return null;
    }

    getCorrespondingSideBarItem(): SideBarElement {
        let element = new SideBarElement();
        element.name = this.name;
        element.iconClass = this.iconClass;
        element.isFavorite = this.isFavorite;
        element.command = this.accessibleForm ? () => { this.accessibleForm.select() } : () => { }
        element.favoriteChanged = this.accessibleForm ? (x) => { this.accessibleForm.setFavorite(x) } : x => { };
        if (this.children.length == 0) return element;
        element.childItems.push(...this.children.map(x => x.getCorrespondingSideBarItem()));
        return element;
    }
}

export class SideBarElement implements SideBarItem {
    isFavorite: boolean;
    name: string;
    iconClass: string;
    command: () => void;
    favoriteChanged: (isFavorite: boolean) => void;
    childItems: SideBarItem[] = new Array();
}


class Menu {
    name: string;
    children: Menu[];
    relatedData: AccessibleFormViewModel;
    orderNo: number;
    icon: string;
    constructor() {
        this.children = [];
    }

    addChild(name: string[], orderNo: number, data: AccessibleFormViewModel) {
        let childName = name.shift();
        if (name.length == 0) {
            let newChild = new Menu();
            newChild.name = childName;
            newChild.orderNo = orderNo;
            newChild.relatedData = data;
            this.children.push(newChild);
        } else {
            let relatedChild = this.children.filter(x => x.name == childName).at(0);
            if (relatedChild == null) {
                let newChild = new Menu();
                newChild.name = childName;
                this.children.push(newChild);
                relatedChild = newChild;
            }
            relatedChild.addChild(name, orderNo, data);
        }
    }

    sort() {
        if (this.children.length > 0) {
            this.children.forEach(x => x.sort());
            this.orderNo = this.children.reduce((a, c) => a < c.orderNo ? a : c.orderNo, 32000);
            this.children.sort((x, y) => x.orderNo - y.orderNo);
        }
    }

    getSortedData(): AccessibleFormViewModel[] {
        if (this.children.length == 0) {
            return [this.relatedData];
        } else {
            let result: AccessibleFormViewModel[] = [];
            this.children.forEach(x => result.push(...x.getSortedData()));
            return result;
        }
    }
}